import BlRadioAv from './BlRadioAv.vue'

BlRadioAv.install = function(Vue) {
  Vue.component(BlRadioAv.name, BlRadioAv)
}

export default BlRadioAv
